import { CommonModule } from '@angular/common';
import { Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { CommonMediaQueries, LetModule, MediaScreenService, SelectComponent, WINDOW } from '@hglobal/common';
import { FormBuilder } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';
import { combineLatest, filter, map, tap } from 'rxjs';

import { Team } from '@pp/core/entities';
import { StorageStore } from '@pp/core/store';

@Component({
  selector: 'pp-team-selector',
  imports: [CommonModule, SelectComponent, TranslateModule, LetModule],
  templateUrl: './team-selector.component.html',
  styleUrl: './team-selector.component.scss',
})
export class TeamSelectorComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #storageStore = inject(StorageStore);
  readonly #window = inject<Window>(WINDOW);
  readonly #destroyRef = inject(DestroyRef);
  readonly #mediaScreenService = inject(MediaScreenService);

  orgCtrl = this.#fb.control(null);
  hasSingleOrg: boolean;
  breakpoints$ = combineLatest({
    isTablet: this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
  });

  organizations$ = toObservable(this.#storageStore.orgId).pipe(
    filter(orgId => !!orgId),
    tap((orgId: number | unknown) => this.#presetFormControl(orgId, this.#storageStore.organizations()?.length)),
    map(() => this.#addIdToTeam(this.#storageStore.organizations())),
  );

  ngOnInit() {
    this.orgCtrl.valueChanges.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(orgId => this.#onOrgIdChange(orgId));
  }

  @HostListener('window:storage')
  onStorageChanged() {
    this.#handleOrgChange();
  }

  #presetFormControl(orgId: number | unknown, teamsCount: number): void {
    this.orgCtrl.setValue(orgId);
    this.hasSingleOrg = teamsCount === 1;
  }

  #addIdToTeam(teams: Team[]): Team[] {
    return teams.map(team => ({ ...team, id: team.orgId }));
  }

  #onOrgIdChange(orgId: number): void {
    if (this.#storageStore.getStoredOrgId() === orgId) {
      return;
    }

    this.#storageStore.storeOrgId(orgId);
    this.#window.location.reload();
  }

  #handleOrgChange(): void {
    if (this.#storageStore.getStoredOrgId() === this.orgCtrl.value) {
      return;
    }

    this.#window.location.reload();
  }
}
